import {ERR_OK} from 'api/config'
export default class Song{
  constructor({id,mid,singer,name,album,duration,image,url}){
  this.id=id
  this.mid=mid
  this.singer=singer
  this.name=name
  this.album=album
  this.duration=duration
  this.image=image
  this.url=url
 }
}

export function createSong(musicData){
    return new Song({
      id:musicData.songid,
      mid:musicData.songmid,
      singer:filterSinger(musicData.singer),
      name:musicData.songname,
      album:musicData.albumname,
      duration:musicData.interval,
      image:`https://y.gtimg.cn/music/photo_new/T002R300x300M000${musicData.albummid}.jpg?max_age=2592000`,
      url:`http://isure.stream.qqmusic.qq.com/C100${musicData.songmid}.m4a?fromtag=32`
      //
    })
}

export function filterSinger(singer){//singer数组存放抓取的数据结构,抓取歌手名字
  let ret=[]
  if(!singer){//若singer为空就返回空
    return ''
  }
  singer.forEach((s)=>{
    ret.push(s.name)
  })
  return ret.join('/')
}


// WEBPACK FOOTER //
// ./src/common/js/song.js